import { RunQueryConfig } from '../../interfaces/hooks/useRapbackSubscriptionTypes';

const getRunQuery = (runQueryConfig: RunQueryConfig) => {
    const { dependencies, pageChanged, filterLabels } = runQueryConfig
    const { initialInvocation, tableName, tableConfig, calledFromAuthHook } = dependencies

    let awaitingExpectedFilters = tableConfig[tableName]?.filter && filterLabels.length < 1

    if (Object.keys(tableConfig).length || initialInvocation) {
        console.log('1010101 debug rb sub useEffect dependencies should only log if tableConfig or initialInvocation are present')
        if ((awaitingExpectedFilters === undefined || awaitingExpectedFilters === true) && !initialInvocation) {
            console.log('debug rb sub condition false')
            return false
        } else if (/* initialInvocation || */ pageChanged) {
            return true

        } else if (calledFromAuthHook && !initialInvocation) {
            return false
        }
    } else {
        return false
    }
}

export default getRunQuery;